import { formatCurrency } from "../../Utils/helpers";

export { formatCurrency };

const AUTO_PAYOUT_NOTE = "Scheduled automatic payout";

export const SOURCE_LABELS = {
  auto: "Automatic",
  admin_batch: "Admin Batch",
  driver_request: "Driver Request",
};

export const formatScheduleLabel = (settings) => {
  if (!settings) return "Semi-Monthly (1st–15th & 16th–End)";

  const getOrd = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const type = settings.payoutCycleType;
  if (type === "weekly") {
    const day = settings.payoutWeeklyDay || "monday";
    return `Weekly (Every ${day.charAt(0).toUpperCase() + day.slice(1)})`;
  }
  if (type === "monthly") {
    return `Monthly (${getOrd(settings.payoutMonthlyDay || 1)} of every month)`;
  }
  const split = settings.payoutCycleSplitDay || 15;
  return `Semi-Monthly (${getOrd(1)}–${getOrd(split)} & ${getOrd(split + 1)}–End)`;
};

export const mapPayoutRequest = (item) => ({
  id: item._id,
  driverId: item.driver?._id,
  name: item.driver?.name || "—",
  email: item.driver?.email || "",
  phone: item.driver?.phone || "",
  requestedAmount: item.amount,
  walletBalance: Number(item.wallet?.balance || 0),
  requestedAt: item.createdAt,
  status: item.status,
  failureReason: item.failureReason || "",
  attempts: item.attempts || 0,
  bankName: item.driver?.bankName || null,
  bankLast4: item.driver?.bankLast4 || null,
  payoutBlocked: !!item.driver?.payoutBlocked,
  blockReason: item.driver?.blockReason || null,
  note: item.note || "",
});

export const mapPendingDriver = (item) => ({
  id: item._id,
  name: item.name,
  email: item.email,
  phone: item.phone,
  walletBalance: item.walletBalance,
  ridesCompleted: item.ridesCompleted || 0,
  bankName: item.bankName,
  bankLast4: item.bankLast4,
  payoutBlocked: !!item.payoutBlocked,
  blockReason: item.blockReason,
  profileImage: item.profileImage,
});

export const mapHistoryItem = (item, scheduleLabel) => {
  const isAuto = item.note === AUTO_PAYOUT_NOTE;
  const processedBy = item.processedBy
    ? [item.processedBy.firstName, item.processedBy.lastName].filter(Boolean).join(" ").trim() || "Admin"
    : isAuto
      ? "Automatic"
      : "Admin";

  const status =
    item.status === "approved"
      ? "completed"
      : item.status === "rejected"
        ? "failed"
        : item.status;

  return {
    id: item._id,
    referenceId: `PAY-${String(item._id).slice(-8).toUpperCase()}`,
    transferId: item.stripeTransferId || null,
    processedAt: item.processedAt || item.updatedAt || item.createdAt,
    weekLabel: scheduleLabel,
    driverCount: 1,
    totalAmount: item.amount,
    status,
    processedBy,
    source: isAuto
      ? "auto"
      : item.note === "Admin-initiated batch payout"
        ? "admin_batch"
        : "driver_request",
    failureReason: item.status === "rejected" ? item.adminNote : null,
    drivers: [
      {
        name: item.driver?.name || "—",
        amount: item.amount,
        bankLast4: item.driver?.bankLast4 || null,
        failed: item.status === "rejected",
      },
    ],
  };
};

export const generateReferenceId = () => {
  const date = new Date();
  const stamp = date.toISOString().slice(0, 10).replace(/-/g, "");
  const rand = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `PAY-${stamp}-${rand}`;
};
